import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { SalesAdminService } from 'src/app/assabil-sales/services/sales-admin-service';
import { TargetType } from 'src/app/assabil-sales/models/entities/target-type';


@Component({
  selector: 'target-type-list',
  templateUrl: './target-type-list.component.html',
  styleUrls: ['./target-type-list.component.scss']
})
export class TargetTypeListComponent extends BasePage2<TargetType > {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  targetTypes: TargetType[] = [];
  // ---------------------------------------------------
  
  //----------------------------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected salesAdminService : SalesAdminService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'targetType';
  }
  //----------------------------------------------------------------------


  //----------------------------------------------------------------------
  listFields = [
      { prop: 'targetTypeCode', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang' },
  ]
  //----------------------------------------------------------------------

  
  //----------------------------------------------------------------------
  getRows(): TargetType[] {
      return this.targetTypes;
  }
  //----------------------------------------------------------------------

  
//----------------------------------------------------------------------
new(){
    let entity : TargetType = new TargetType();
    entity.inserted = true;
    entity.edit = true;
    this.targetTypes.push(entity);
    this.targetTypes = [...this.targetTypes];
}
//----------------------------------------------------------------------

       

//----------------------------------------------------------------------
saveRow(targetType: TargetType): Promise<TargetType> {
    return this.salesAdminService.targetTypeSave(targetType);
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
loadData() {
    this.salesAdminService.targetTypesGet(this.code, this.name).then(result => {
        this.targetTypes = result;
    })
}
//----------------------------------------------------------------------

}


